var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup-right-click" }, [
    _vm.useOpen
      ? _c(
          "div",
          {
            staticClass: "menu-list",
            on: {
              click: function($event) {
                _vm.$emit("open")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/foldering/open.svg"),
                alt: "open-icon"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Open")])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useOpen
      ? _c(
          "div",
          {
            staticClass: "menu-list",
            on: {
              click: function($event) {
                _vm.$emit("open-new-tab")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/foldering/open.svg"),
                alt: "open-tab-icon"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Open in New Tab")])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useMove
      ? _c(
          "div",
          {
            staticClass: "menu-list",
            on: {
              click: function($event) {
                _vm.$emit("move")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/foldering/move.svg"),
                alt: "open-icon"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Move to")])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useDownload
      ? _c(
          "div",
          {
            staticClass: "menu-list",
            on: {
              click: function($event) {
                _vm.$emit("download")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/foldering/download.svg"),
                alt: "open-icon"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Download")])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useRename
      ? _c(
          "div",
          {
            staticClass: "menu-list",
            on: {
              click: function($event) {
                _vm.$emit("rename")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/foldering/rename.svg"),
                alt: "open-icon"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Rename")])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useDelete
      ? _c(
          "div",
          {
            staticClass: "menu-list",
            on: {
              click: function($event) {
                _vm.$emit("delete")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/foldering/delete.svg"),
                alt: "open-icon"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Delete")])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.useDetail
      ? _c(
          "div",
          {
            staticClass: "menu-list",
            on: {
              click: function($event) {
                _vm.$emit("detail")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/foldering/detail.svg"),
                alt: "open-icon"
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Detail")])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50f4c961", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f4c961","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/jPopupRightClick.vue
// module id = null
// module chunks = 